// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

//   React components
import MDBox from "components/MDBox";

//   React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/authentication/components/Footer";

function BasicLayout({image, children}) {
  return (
    <PageLayout>
      {/* <DefaultNavbar
        action={{
          type: "external",
          route: "/",
          label: "HRM",
          color: "dark",
        }}
      /> */}
      <MDBox
        display="flex"
        flexDirection="column"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({functions: {linearGradient, rgba}, palette: {gradients}}) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}
      >
        <MDBox
          flex={1}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          px={1}
          width="100%"
          mx="auto"
        >
          <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
            <Grid item xs={10} sm={8} md={5} lg={4} xl={3} mt={2}>
              {children}
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </PageLayout>
  );
}

BasicLayout.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default BasicLayout;
